import React from 'react';
import { CreditApprovalStep, CreditApprovalStepDecision } from '@indigo-ag/schema';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faBan, faCheck, faFlag } from '@fortawesome/pro-regular-svg-icons';
import { Body, palettes } from '@indigo-ag/component-module';

import i18next from 'core/i18n';

const DECISION_TRANSLATION: Record<CreditApprovalStepDecision, string> = {
  [CreditApprovalStepDecision.APPROVED]: i18next.t('approved'),
  [CreditApprovalStepDecision.DENIED]: i18next.t('denied')
};

const DECISION_ICON: Record<CreditApprovalStepDecision, IconDefinition> = {
  [CreditApprovalStepDecision.APPROVED]: faCheck,
  [CreditApprovalStepDecision.DENIED]: faBan
};

const DECISION_COLOR: Record<CreditApprovalStepDecision, string> = {
  [CreditApprovalStepDecision.APPROVED]: palettes.brand.green.darker,
  [CreditApprovalStepDecision.DENIED]: palettes.brand.red.darker
};

interface CreditApprovalStepStatusProps {
  stepDecision: CreditApprovalStep['decision'];
}

export const CreditApprovalStepStatus: React.FunctionComponent<CreditApprovalStepStatusProps> = ({ stepDecision }) => {
  return (
    <div className="flex align-items-center">
      <FontAwesomeIcon
        icon={stepDecision ? DECISION_ICON[stepDecision] : faFlag}
        color={stepDecision ? DECISION_COLOR[stepDecision] : undefined}
      />
      <Body className="ml-1" style={stepDecision ? { color: DECISION_COLOR[stepDecision] } : undefined}>
        {stepDecision ? DECISION_TRANSLATION[stepDecision] : i18next.t('notStarted')}
      </Body>
    </div>
  );
};
